export default __webpack_public_path__ + "static/hong-kong-hotel-44f57b4616ab1602509482f6ad6c20dc.jpg";